export const MESSAGE_KEY_PATTERN = /^productPage\./;
